import { nextTick, provide } from 'vue'

export function useLazyRenderWaiter(callback: () => void) {
	let completedRenders = 0
	let lazyRenderCount: number = 0

	provide('registerLazyRender', () => {
		lazyRenderCount++
	})

	provide('triggerLazyRender', async () => {
		completedRenders++
		await nextTick()
		if (completedRenders === lazyRenderCount) {
			callback()
		}
	})
}
